import React from 'react';

import {
  StyledContainer,
  StyledFirstCell,
  StyledSecondCell,
} from './styles/contentAndQrStyles';

type ListAndQrProps = {
  contentSlot: React.ReactNode;
  qrSlot: React.ReactNode;
  underQrSlot?: React.ReactNode;
  underContentSlot?: React.ReactNode;
};

export const ContentAndQr = ({
  contentSlot,
  qrSlot,
  underQrSlot,
  underContentSlot,
}: ListAndQrProps) => {
  return (
    <>
      <StyledContainer
        container
        direction="row"
        wrap="nowrap"
        justifyContent="center"
      >
        <StyledFirstCell>{contentSlot}</StyledFirstCell>
        <StyledSecondCell>{qrSlot}</StyledSecondCell>
      </StyledContainer>
      <StyledContainer
        container
        direction="row"
        wrap="nowrap"
        justifyContent="center"
      >
        <StyledFirstCell>{underContentSlot}</StyledFirstCell>
        <StyledSecondCell>{underQrSlot}</StyledSecondCell>
      </StyledContainer>
    </>
  );
};
